/**
 * LinkedIn Insight Tag.
 *
 * The base tag loads on all PUBLIC pages: public/index.html inserts it just
 * before </body> at initial load (skipping signed-in app/admin routes), and
 * ensureLinkedInInsight() covers SPA navigation into a public route when the
 * visitor entered on an app route. Both share window.__liInsightLoaded so the
 * tag is never inserted twice.
 *
 * PRIVACY: no customer data (no email, name, organization or id) is ever
 * passed to LinkedIn. The only conversion payload is the numeric
 * conversion_id; the session label used by the duplicate guard stays in this
 * browser's localStorage.
 */
export const LINKEDIN_PARTNER_ID = "5738346";

/** "Webinar registration" conversion configured in LinkedIn Campaign Manager. */
export const LINKEDIN_WEBINAR_CONVERSION_ID = 30753914;

const APP_ROUTE_PREFIXES = ["/dashboard", "/intake", "/analysis", "/admin", "/briefings", "/diagnostic", "/submit-review"];

const FIRED_KEY = "w3rc_li_webinar_fired";

export function ensureLinkedInInsight(pathname) {
  if (typeof window === "undefined" || window.__liInsightLoaded) return;
  if (APP_ROUTE_PREFIXES.some((p) => pathname.startsWith(p))) return;
  window.__liInsightLoaded = true;
  /* Official LinkedIn Insight Tag snippet. */
  window._linkedin_partner_id = LINKEDIN_PARTNER_ID;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID);
  (function (l) {
    if (!l) {
      window.lintrk = function (a, b) { window.lintrk.q.push([a, b]); };
      window.lintrk.q = [];
    }
    const s = document.getElementsByTagName("script")[0];
    const b = document.createElement("script");
    b.type = "text/javascript";
    b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);
  })(window.lintrk);
}

/**
 * Fires the webinar registration conversion at the moment /webinar reports a
 * successful submit. Never on page load. The guard is keyed on the session
 * the visitor registered for, so a double-submit or a page revisit cannot
 * double-count, while a genuine registration for a different session still
 * counts. No customer data is included.
 */
export function fireWebinarRegistrationConversion(sessionKey) {
  if (typeof window === "undefined") return;
  const key = sessionKey || "unknown-session";
  try {
    if (window.localStorage.getItem(FIRED_KEY) === key) return;
    window.localStorage.setItem(FIRED_KEY, key);
  } catch {
    /* storage unavailable: still at most once per successful submit */
  }
  if (typeof window.lintrk !== "function") return; // tag not loaded on this entry path
  window.lintrk("track", { conversion_id: LINKEDIN_WEBINAR_CONVERSION_ID });
}
